import { Menu } from '@mantine/core'
import PrimaryDropDown from 'app/views/components/DropDown/DropDown'
import { useDispatch } from 'react-redux'
import { FacilityReverseParams } from 'app/models/facility-reverse-params'
import {
  approveFacilityReverse,
  deleteDraftFacilityReverse,
  rejectFacilityReverse,
  submitFacilityReverse,
} from './facility-reverse-daml-actions'
import IonIcon from '@reacticons/ionicons'

type Props = {
  row: FacilityReverseParams
}

// Edit is intentionally not surfaced — rewriting the reason after the fact
// would weaken the audit trail. A drafted reverse can be submitted for manager
// approval or deleted; a submitted reverse can be approved or rejected.
// Approved reverses have no further actions.
//
// Delete matters because a rejection returns a reversal to Draft: without it,
// that leftover would sit as an open reverse and block the transaction from
// ever being reverted again.
export default function FacilityReverseActions({ row }: Props) {
  const dispatch = useDispatch()
  const status = row?.status?.toLowerCase()

  if (status === 'draft') {
    return (
      <Menu shadow="md" width={220} position="bottom" withinPortal>
        <Menu.Target>
          <div style={{ width: 'fit-content' }}>
            <PrimaryDropDown>Actions</PrimaryDropDown>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            icon={
              <IonIcon
                className="action-ion-icon"
                name="paper-plane-outline"
              />
            }
            onClick={() => submitFacilityReverse(row, dispatch)}
          >
            Submit for Approval
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            color="red"
            icon={
              <IonIcon className="action-ion-icon" name="trash-outline" />
            }
            onClick={() => deleteDraftFacilityReverse(row, dispatch)}
          >
            Delete
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    )
  }

  if (status === 'submitted') {
    return (
      <Menu shadow="md" width={220} position="bottom" withinPortal>
        <Menu.Target>
          <div style={{ width: 'fit-content' }}>
            <PrimaryDropDown>Actions</PrimaryDropDown>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            icon={
              <IonIcon
                className="action-ion-icon"
                name="checkmark-circle-outline"
              />
            }
            onClick={() => approveFacilityReverse(row, dispatch)}
          >
            Approve
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            color="red"
            icon={
              <IonIcon
                className="action-ion-icon"
                name="close-circle-outline"
              />
            }
            onClick={() => rejectFacilityReverse(row, dispatch)}
          >
            Reject
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    )
  }

  return null
}
